import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';

import Home from '../pages/home';
import AboutUs from '../pages/aboutus';
import AboutCommit from '../pages/aboutcommit';
import AboutObject from '../pages/aboutobject';
import ServicesFMS from '../pages/servfms';
import ServicesCommunity from '../pages/servcomm';
import ServicesConsultancy from '../pages/servconsult';
import Approach from '../pages/approach';
import Standards from '../pages/standards';
import CAFMSys from '../pages/cafmsys';
import QualityControl from '../pages/qualitycontrol';
import BizPartners from '../pages/bizpartners';
class MenuRouter extends Component {

    state = {
        subDir: '/fms'
    }

    render() {
        const { menuVisible } = this.props;
        const { subDir } = this.state; 

        return (
            <Switch>
                <Route exact path="/" 
                    render={(props) => <Home  {...props} /> } 
                />
                <Route exact path="/home" 
                    render={(props) => <Home  {...props} /> } 
                />
                <Route exact path="/aboutus" 
                    render={(props) => <AboutUs {...props} /> } 
                />
                <Route exact path="/aboutcommit" 
                    render={(props) => <AboutCommit {...props} /> } 
                />
                <Route exact path="/aboutobject" 
                    render={(props) => <AboutObject {...props} />} 
                />
                <Route exact path="/servfms" 
                    render={(props) => <ServicesFMS {...props} />} 
                />
                <Route exact path="/servcomm" 
                    render={(props) => <ServicesCommunity {...props} />} 
                />
                <Route exact path="/servconsult" 
                    render={(props) => <ServicesConsultancy {...props} />} 
                />
                <Route exact path="/approach" 
                    render={(props) => <Approach {...props} />} 
                />
                <Route exact path="/standards" 
                    render={(props) => <Standards {...props} />} 
                />
                <Route exact path="/cafm" 
                    render={(props) => <CAFMSys {...props} />} 
                />
                <Route exact path="/qc" 
                    render={(props) => <QualityControl {...props} />} 
                />
                <Route exact path="/bizpartners" 
                    render={(props) => <BizPartners {...props} />} 
                />
            </Switch>
        );
    }
};

export default MenuRouter;